<template>
  <div class="wh-screen">
    <global-confirm-box ref="confirmBox" />
    <warehouse-dialog v-model="warehouseDialog" :edited-item="editedItem" @create="onWarehouseCreated" @update="onWarehouseUpdated" />
    <warehouse-doc-screen
      :loading="whLoading"
      :mobile="device.isMobile"
      :columns="columns"
      :rows="rows"
      :actions="actions"
      :empty="empty"
      clickable
      @action="warehouseDialog = true"
      @open-row="editItem($event.raw)"
      @toast="$emit('toast', $event)"
    >
      <template #row-actions="{ row }">
        <warehouse-row-button icon="mdi-pencil-outline" :label="$t('edit')" tone="pri" action="edit" @click="editItem(row.raw)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteItem(row.raw)" />
      </template>
    </warehouse-doc-screen>
  </div>
</template>

<script>
import WarehouseTabWarehouse from "@/components/warehouse/tabs/WarehouseTabWarehouse.vue";
import warehouseService from "@/services/warehouse";
import WarehouseDocScreen from "../../docs/WarehouseDocScreen.vue";
import WarehouseRowButton from "../../docs/WarehouseRowButton.vue";

/**
 * Magacini: lista magacina sa izmenom i brisanjem, "Novi magacin" u traci alata. Nasleđuje učitavanje, dijalog,
 * brisanje, štampu i Excel iz starog taba.
 */
export default {
  name: "WarehouseScreenWarehouses",
  extends: WarehouseTabWarehouse,
  components: { WarehouseDocScreen, WarehouseRowButton },
  data: () => ({
    whLoading: true,
  }),
  computed: {
    columns() {
      return [
        { key: "name", label: this.$t("title"), main: true, mobile: "title" },
        { key: "location", label: this.$t("address"), mobile: "meta" },
        { key: "notes", label: this.$t("note"), mobile: "meta" },
      ];
    },
    rows() {
      return this.exportItems.map((item) => ({
        key: item.id,
        raw: item,
        name: item.name || "",
        location: item.location || "",
        notes: item.notes || "",
      }));
    },
    actions() {
      return [{ key: "new", label: this.$t("new_warehouse"), icon: "mdi-plus", tone: "pri" }];
    },
    empty() {
      return {
        icon: "mdi-warehouse",
        title: this.$t("no_warehouses"),
        text: this.$t("no_warehouses_added_yet"),
      };
    },
    shownKpis() {
      return this.whLoading ? [] : [{ key: "warehouses", label: this.$t("warehouses"), value: this.rows.length, tone: "inverse" }];
    },
  },
  watch: {
    shownKpis: {
      handler(kpis) {
        this.$emit("kpis", kpis);
      },
      immediate: true,
    },
    whLoading: {
      handler(loading) {
        this.$emit("loading", loading);
      },
      immediate: true,
    },
  },
  methods: {
    /** Isto što i stari tab, uz oznaku učitavanja (da se do odgovora ne vidi "nema magacina"). */
    async initialize() {
      this.whLoading = true;
      try {
        const res = await warehouseService.getWarehouses();
        this.warehouses = res.data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_warehouses"));
      } finally {
        this.whLoading = false;
      }
    },
  },
};
</script>
